"use client";
import Image from "next/image";
import React, { Component, ErrorInfo, ReactNode } from "react";
import { Coffee } from "../common/Icons";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center flex-col-reverse lg:flex-row justify-center h-screen gap-[20px] xl:gap-[20px] 2xl:gap-[50px] bg-gradient-background relative px-8">
          <span className="max-w-[40px] sm:max-w-[60px] xl:max-w-[77px] absolute top-[80%] sm:top-[70%] left-[84%] sm:left-[75%] lg:left-[45%] rotate-[13deg]">
            <Coffee />
          </span>
          <div className="relative">
            <span className="max-w-[40px] sm:max-w-[60px] xl:max-w-[77px] absolute top-0 left-[-5%] sm:left-[-12%] rotate-[-13deg]">
              <Coffee />
            </span>
            <p className="ff_poppins font-semibold text-2xl sm:text-3xl md:text-4xl xl:text-5xl 3xl:text-[52px] text-[#333333] mb-3 text-center lg:text-start">
              Error 500-ish... <br />
              Code Had a Coffee Break!
            </p>
            <p className="ff_poppins font-semibold text-lg sm:text-xl lg:text-2xl text-[#333333] mb-6 text-center lg:text-start max-w-[550px] 3xl:max-w-full w-full">
              We were just running perfectly... until we weren’t.
              <br />
              Our developers are probably already <br />
              debugging in panic mode.
            </p>
            <p className="ff_poppins font-semibold text-base sm:text-lg lg:text-xl text-[#333333] text-center lg:text-start">
              In the meantime:
            </p>
            <ul className="ff_poppins font-semibold text-base sm:text-lg lg:text-xl text-[#333333] lg:list-disc pl-[30px] text-center lg:text-start">
              <li>Check your internet connection</li>
              <li>Try again in a moment</li>
            </ul>
          </div>
          <Image
            className="max-w-[400px] xl:max-w-[600px] 2xl:max-w-[750px] 3xl:max-w-[900px] w-full"
            src={"/assets/images/png/error.png"}
            alt="error"
            width={900}
            height={600}
          />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
